import { render, staticRenderFns } from "./SimpleFilters.vue?vue&type=template&id=1d3697b8&"
import script from "./SimpleFilters.vue?vue&type=script&lang=js&"
export * from "./SimpleFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d3697b8')) {
      api.createRecord('1d3697b8', component.options)
    } else {
      api.reload('1d3697b8', component.options)
    }
    module.hot.accept("./SimpleFilters.vue?vue&type=template&id=1d3697b8&", function () {
      api.rerender('1d3697b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/SimpleFilters.vue"
export default component.exports